/* eslint-disable no-extra-boolean-cast */
/* eslint-disable no-undef */
/* eslint-disable dot-notation */
import { Platform, Linking, Dimensions } from 'react-native';
import axios from 'axios';
import DeviceInfo from 'react-native-device-info';
import { resetCart } from '../store/cart.slice';
import { logout, setCustomer } from '../store/customer.slice';
import { hideLoader, resetPaymentGateways, setCafes, setCCPaymentMethods, setInfo, showAlert, showLoader, showToast } from '../store/info.slice';
import store from '../store/store';
import { doGet, doPost } from './http';
import navigationService from './NavigationService';
import * as storage from './storage';
import * as BluetoothPrintService from './BluetoothPrintService';
import environment from '../environment';
import { setThermalPrinters } from '../store/thernam.printers.slice';
import { MD2Colors } from 'react-native-paper';
import { resetData as resetOrdersData } from '../store/orders.slice';
import { resetData as resetOrderDetailsData } from '../store/order.details.slice';
import { applyWebSeo } from './WebSeo';

export const Mobile_RegExp = /^[6-9]\d{9}$/; // Indian 10-digit mobile numbers starting with 6-9
export const Email_RegExp = /^[^\s@]+@[a-zA-Z0-9._-]+\.[a-zA-Z]{2,}$/;
export const PACKAGE_NAME = DeviceInfo.getBundleId();
export const IS_PROD = environment.ENV === 'production';
export const getKeyboardBehavior = Platform.OS === 'ios' ? 'padding' : 'height';
export const NETWORK_ERROR_MSG = "You're currently offline. Please turn on your internet connection and retry.";
let accessTokenRotationPromise = null;
let rotatingAccessToken = null;

const isPublicAuthRequest = (request) => /\/(?:login|auth)(?:\/|$)/.test(String(request?.url || ''));
const getRequestAccessToken = (request) => request?.__ccAccessToken || null;
const resetExpiredSession = async (expectedAccessToken) => {
    if (expectedAccessToken && await storage.getData('accessToken') !== expectedAccessToken) return false;
    await resetCustomerActivity();
    navigationService.navigation?.navigate('Login');
    return true;
};
/**
 * Extracts the domain from a URL by removing protocol and www prefix
 * @param {string} url - The URL to extract domain from
 * @returns {string} The extracted domain
 * @example extractDomain('https://www.example.com/path') // returns 'example.com'
 */
export const extractDomain = (url) => {
    return url.replace(/^https?:\/\/(www\.)?/, '').split('/')[0];
};
/**
 * Gets the base URL for API requests based on platform
 * For web: uses window.location.origin (or localhost for local dev)
 * For native: uses environment.BASE_URL
 * @returns {string} The base URL
 */
export const BASE_URL = () => {
    if (Platform.OS === 'web') {
        console.log('window.location.origin', window.location.origin);
        return (window.location.origin).includes('localhost') ? 'http://localhost:3000' : window.location.origin;
    }
    return environment.BASE_URL;
};
/**
 *  Gets the reports base URL based on platform
 * @returns
 * {string} Reports Base URL for API calls
 */
export const REPORTS_BASE_URL = () => {
    // Native / mobile platforms
    if (Platform.OS !== 'web') {
        return environment.REPORTS_BASE_URL;
    }

    // Web platform
    if (typeof window === 'undefined') {
        return '';
    }

    const { protocol, hostname } = window.location;

    // Local development
    if (hostname.includes('localhost')) {
        return 'http://localhost:3001';
    }

    // tistl.in special handling
    if (hostname.includes('tistl.in')) {
        return `${protocol}//reports${hostname}`;
    }

    // Default case
    return `${protocol}//reports.${hostname}`;
};
export const REPORTS_API_URL = `${REPORTS_BASE_URL()}/api`;
export const API_URL = `${BASE_URL()}/api`;
export const CASH_COUNTER_API_URL = `${BASE_URL()}/api/cash-counter`;
export const SITE_URL = BASE_URL();
export const REQUEST_TIME_OUT = 1000 * 30; // 30 seconds
export const identifier = (extractDomain(BASE_URL())).replace(/^https?:\/\//, '').replace(/^www\./, '');

/**
 * Base headers included in every API request
 * Includes content type, platform, app flavor, and app identifier
 */
export const baseHeaders = {
    'Content-Type': 'application/json',
    'X-Auth-Token-Rotation': 'access-only',
    'X-Platform': environment.PLATFORM,
    'X-App-Flavor': environment.ENV,
    'X-App-Identifier': identifier,
    'identifier': identifier,
};

/**
 * Mobile-specific headers with device information
 * Includes app version, build number, device model, OS version, etc.
 * Only added on Android and iOS platforms
 */
export const mobileHeaders =
    Platform.OS === 'android' || Platform.OS === 'ios'
        ? {
            'X-App-Name': DeviceInfo.getApplicationName(),
            'X-App-Version': DeviceInfo.getVersion(),         // e.g. 1.0.3
            'X-Build-Number': DeviceInfo.getBuildNumber(),    // e.g. 42
            'X-Package-Name': DeviceInfo.getBundleId(),       // e.g. com.example.app
            'X-Device-Brand': DeviceInfo.getBrand(),          // e.g. Apple / Xiaomi
            'X-Device-Model': DeviceInfo.getModel(),          // e.g. iPhone 14
            'X-OS-Version': DeviceInfo.getSystemVersion(),    // e.g. 17.5
            'X-App-Platform': Platform.OS,                    // 'ios' or 'android'
            'X-Device-Type': DeviceInfo.getDeviceType(),
            'X-Device-Id': DeviceInfo.getDeviceId(),
            'X-Device-UniqueId': DeviceInfo.getUniqueIdSync(),
            'X-Is-Emulator': DeviceInfo.isEmulatorSync(),
        }
        : {};


export const HOME_OPTIONS = [
    { label: 'My Account', key: 'profile', icon: 'account-outline', screen: 'MyAccount' },
    { label: 'Orders', key: 'orders', icon: 'cube-outline', screen: 'Orders' },
    { label: 'Cart', key: 'cart', icon: 'cart-outline', screen: 'Cart' },
];

/**
 * Returns a color based on the ratio of current to max value
 * @param {number} current - Current value
 * @param {number} max - Maximum value
 * @returns {string} Color hex code (green for <=50%, orange for <=70%, red for >70%)
 */
export const getProgressColor = (current, max) => {
    const ratio = current / max;
    if (ratio <= 0.5) { return '#4caf50'; }   // green
    if (ratio <= 0.7) { return '#ff9800'; }   // orange
    return '#f44336';                     // red
};

export const scaleFont = (size, factor = 0.2) => {
    const SCREEN_WIDTH = Dimensions.get('window').width;
    const BASE_WIDTH = 375;
    const scale = SCREEN_WIDTH / BASE_WIDTH;
    const newSize = size + (size * (scale - 1)) * factor;
    return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

/**
 * Extracts error message from API error response
 * @param {Error} error - The error object from axios
 * @returns {string} User-friendly error message
 */
export const getErrorMsg = (error) => {
    try {
        if (error?.message !== 'Network Error') {
            if (error?.response) {
                return error.response?.data?.msg || error.response?.data?.message || error.response?.data?.error || 'Something went wrong.Please try again later';
            } else {
                return 'Something went wrong.Please try again later';
            }
        }
    } catch (e) {
        console.error(e);
    }
    return 'Something went wrong.Please try again later';
};

/**
 * Gets error message for async thunk operations, handling network errors specially
 * @param {Error} error - The error object
 * @returns {string} User-friendly error message (network error or generic error)
 */
export const getAsyncThunkMsg = (error) => {
    try {
        if (error?.message === 'Network Error') {
            return NETWORK_ERROR_MSG;
        }
        return getErrorMsg(error) || error?.message || 'Something went wrong.Please try again later';
    } catch (e) {
        console.error(e);
    }
    return 'Something went wrong.Please try again later';
};

/**
 * Global error handler that displays errors as toast or alert
 * Handles 401 errors by logging out user
 * @param {Error} error - The error object
 * @param {('alert'|'toast')} [displayMode='alert'] - How to display the error
 * @returns {Promise<void>}
 */
export const errorHandler = async (error, displayMode = 'alert') => {
    try {
        store.dispatch(hideLoader());
        await delay(500);
        console.log('error Handler', JSON.stringify(error?.response));
        console.log('error Handler', error?.message);
        if (error?.message !== 'Network Error') {
            let message = getErrorMsg(error);
            if (error?.response) {
                if (displayMode === 'toast') {
                    store.dispatch(showToast({ message, type: 'error' }));
                } else {
                    store.dispatch(showAlert(message));
                }
                if (error.response?.status === 401) {
                    // Match cc-customer: let the access-token interceptor
                    // retry before this fallback clears session state.
                    await resetCustomerActivity({ removeAccessToken: false });
                    navigationService.navigation.navigate('Login');
                }
            } else {
                if (displayMode === 'toast') {
                    store.dispatch(showToast({ message, type: 'error' }));
                } else {
                    store.dispatch(showAlert(message));
                }
            }
        }
    } catch (e) {
        console.log(e);
    }
};

export const breakpoints = {
    xs: 1,  // Phones
    sm: 2,  // Small tablets
    md: 1,  // Tablets
    lg: 1,  // Large screens
    xl: 1,  // Large screens
    xxl: 1,
};

export const TXN_TYPE_COLOR = {
    'create': MD2Colors.green700,
    'load': MD2Colors.green700,
    'redeem': MD2Colors.red600,
    'cancel load': MD2Colors.red600,
    'cancel redeem': MD2Colors.green700,
};

/**
 * Calculates number of columns for responsive grid based on screen width
 * @param {number} width - Screen width in pixels
 * @returns {number} Number of columns to display
 */
export const getNumColumns = (width) => {
    if (width < 500) { return breakpoints.xs; }
    if (width < 576) { return breakpoints.sm; }
    if (width < 768) { return breakpoints.md; }
    if (width < 992) { return breakpoints.lg; }
    if (width < 1200) { return breakpoints.xl; }
    if (width < 1400) { return breakpoints.xxl; }
    return breakpoints.xxl;
};

/**
 * Calculates item width for responsive grid layout
 * @param {number} width - Screen width in pixels
 * @returns {number} Item width in pixels (2-5 items per row depending on screen size)
 */
export const getItemWidth = (width) => {
    if (width > 1200) {
        return (width / 5 - 16); // Large screens (5 items per row)
    } else if (width > 800) {
        return (width / 4 - 16); // Medium screens (4 items per row)
    } else if (width > 600) {
        return (width / 3 - 16); // Small screens (3 items per row)
    } else {
        return (width / 2 - 16); // Extra small screens (2 items per row)
    }
};

export const orderBreakpoints = {
    xs: 1,
    sm: 1,
    md: 2,
    lg: 2,
    xl: 3,
    xxl: 4,
};


/**
 * Calculates number of columns for orders grid based on screen width
 * @param {number} width - Screen width in pixels
 * @returns {number} Number of columns (1-4 based on breakpoints)
 */
export const getOrdersNumColumns = (width) => {
    if (width < 576) { return orderBreakpoints.xs; }
    if (width < 768) { return orderBreakpoints.sm; }
    if (width < 992) { return orderBreakpoints.md; }
    if (width < 1200) { return orderBreakpoints.lg; }
    if (width < 1400) { return orderBreakpoints.xl; }
    return orderBreakpoints.xxl;
};

/**
 * Calculates order item width for responsive layout
 * @param {number} width - Screen width in pixels
 * @returns {number} Item width in pixels (1-3 items per row)
 */
export const getOrderItemWidth = (width) => {
    if (width > 1078) {
        return (width / 3 - 16); // Large screens (5 items per row)
    } else if (width > 800 && width < 1078) {
        return (width / 2 - 16); // Medium screens (4 items per row)
    } else if (width > 600) {
        return (width / 1 - 16); // Small screens (3 items per row)
    } else {
        return (width / 1 - 16); // Extra small screens (2 items per row)
    }
};

/**
 * Extracts query parameter value from URL
 * @param {string} key - Parameter name to extract
 * @param {string} url - URL to parse
 * @returns {string|null} Parameter value or null if not found
 */
export const getParameterByName = (key, url) => {
    key = key.replace(/[[\]]/g, '\\$&');
    let regex = new RegExp('[?&]' + key + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) { return null; }
    if (!results[2]) { return ''; }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};


/**
 * Fetches user profile and initializes platform-specific services (Bluetooth/Thermal printer)
 * @returns {Promise<Object>} User profile data
 */
export const getProfile = () => new Promise((resolve, reject) => {
    doGet('profile').then(response => {
        store.dispatch(setCustomer(response.data));
        if (Platform.OS === 'android') {
            BluetoothPrintService.initBluetoothSetup(response?.data);
        } else {
            initThermalPrinter(response.data);
        }
        resolve(response.data);
    }).catch(error => {
        reject(error);
    });
});

/**
 * Fetches payment gateways and cash counter payment methods, dispatches them to the store, and returns both datasets.
 * @param {object} params - Optional query params for payment gateways
 * @returns {Promise<{paymentGateways: any, cashCounterMethods: any}>}
 */
export const getPaymentGateways = async () => {
    try {
        const cafe_id = store?.getState()?.customer?.customer?.cafe_id;
        const cc_pgs = await doGet('payment-methods', { cafe_id });
        store.dispatch(setCCPaymentMethods(cc_pgs.data));
        return { cashCounterMethods: cc_pgs.data };
    } catch (error) {
        console.error(error);
        throw error;
    }
};

/**
 * Initializes thermal printer for Electron desktop app
 * Restores saved printer settings and fetches available printers
 * @param {Object} customer - Customer object with enable_cash_counter_print flag
 * @returns {Promise<void>}
 */
export const initThermalPrinter = (customer) => new Promise(async (resolve, reject) => {
    try {
        if (isElectron() && customer?.enable_cash_counter_print) {
            const connected_thermal_printer = await storage.getData('connected_thermal_printer');
            const paper_size = await storage.getData('paper_size');
            if (!!connected_thermal_printer) {
                await window?.electronAPI?.setPrinter(connected_thermal_printer);
            }
            if (!!paper_size) {
                await window?.electronAPI?.setPaperSize(paper_size);
            }
            const printers = await window?.electronAPI?.getPrinters();
            store.dispatch(setThermalPrinters(printers));
        }
    } catch (error) {
        console.error(error);
    }
});

/**
 * Fetches app info (theme, settings, etc.) and loads cafes if configured
 * @returns {Promise<Object>} App info object
 */
export const getInfo = () => new Promise((resolve, reject) => {
    doGet('info').then(response => {
        applyWebSeo(response.data, { appName: 'Cash Counter' });
        store.dispatch(setInfo(response.data));
        const settings = response.data?.settings;
        if (!!settings?.show_cafes_in_signup) {
            getAggrCafes();
        }
        resolve(response.data);
    }).catch(error => {
        reject(error);
    });
});

/**
 * Fetches company info and dispatches to Redux store
 * @returns {Promise<Object>} Company info object
 */
export const getCompanyInfo = () => new Promise((resolve, reject) => {
    doGet('company/info').then(response => {
        store.dispatch(setInfo(response.data));
        resolve(response.data);
    }).catch(error => {
        reject(error);
    });
});


/**
 * Checks if mobile/email exists in system
 * @param {Object} params - Request params containing email, mobile, action
 * @param {string} [params.email] - User email
 * @param {string} [params.mobile] - User mobile number
 * @param {string} params.action - Action type
 * @returns {Promise<Object>} Check result
 */
export const checkMobile = (params) => new Promise((resolve, reject) => {
    store.dispatch(showLoader());
    doPost('/check-mobile', params).then(response => {
        store.dispatch(hideLoader());
        resolve(response.data);
    }).catch(error => {
        store.dispatch(hideLoader());
        reject(error);
    });
});

/**
 * Sends forgot password request
 * @param {Object} params - Request params (email/mobile)
 * @returns {Promise<Object>} Response data
 */
export const forgotPassword = (params, config) => new Promise((resolve, reject) => {
    // store.dispatch(showLoader());
    doPost('/password/forgot', params, config).then(response => {
        // store.dispatch(hideLoader());
        resolve(response.data);
    }).catch(error => {
        // store.dispatch(hideLoader());
        reject(error);
    });
});

/**
 * Clears all user data from storage and resets Redux state (cart, orders, customer)
 * @returns {Promise<void>}
 */
export const resetCustomerActivity = async ({ removeAccessToken = true } = {}) => {
    try {
        await delay(500);
        if (removeAccessToken) {
            await storage.deleteData('accessToken');
        }
        store.dispatch(resetCart());
        store.dispatch(resetOrdersData());
        store.dispatch(resetOrderDetailsData());
        store.dispatch(resetPaymentGateways());
        store.dispatch(logout());
    } catch (error) {
        console.log(error);
    }
};

/**
 * Handles user logout - calls logout API, clears data, and navigates to Login
 * @returns {Promise<void>}
 */
export const logoutHandler = async () => {
    try {
        store.dispatch(showLoader());
        const accessToken = await storage.getData('accessToken');
        if (accessToken) {
            const { data } = await doPost('logout', { accessToken });
            store.dispatch(showToast(data?.message));
        }
        await resetCustomerActivity();
        store.dispatch(hideLoader());
        navigationService.navigation.replace('Login');
    } catch (error) {
        console.log(error);
        store.dispatch(hideLoader());
        errorHandler(error);
    }
};

/**
 * Navigates back if possible, otherwise goes to Splash screen
 * @param {Object} navigation - React Navigation navigation object
 */
export const navigationGoBack = (navigation) => {
    if (navigation.canGoBack()) {
        navigation.goBack();
    } else {
        navigation.replace('Splash');
    }
};

/**
 * Fetches list of cafes/restaurants and stores in Redux
 * Only fetches if not already loaded
 * @returns {Promise<void>}
 */
export const getAggrCafes = async () => {
    try {
        console.log('store?.getState()?.info?.cafes', store?.getState()?.info?.cafes);
        if (store?.getState()?.info?.cafes.length === 0) {
            store.dispatch(showLoader());
            const response = await doGet('/cafes');
            console.log(response.data);
            store.dispatch(hideLoader());
            store.dispatch(setCafes(response?.data || []));
        }
    } catch (error) {
        console.error(error);
        store.dispatch(hideLoader());
        errorHandler(error);
    }
};

/**
 * Converts hexadecimal UID to decimal card number (little-endian)
 * @param {string} uidHex - Hexadecimal UID string
 * @returns {string|null} Decimal card number or null on error
 */
export const convertUidToCustomCardNumber = (uidHex) => {
    let cardNumber = null;
    try {
        // Reverse bytes for little-endian interpretation
        const reversedHex = uidHex.match(/.{1,2}/g).reverse().join('');
        cardNumber = BigInt('0x' + reversedHex).toString();
    } catch (error) {
        console.error('hexToDecimalReversed error', error);
    }
    return cardNumber;
};

/**
 * Checks if app is running in Electron desktop environment
 * @returns {boolean} True if running in Electron
 */
export const isElectron = () => {
    if (Platform.OS === 'web') {
        return typeof window !== 'undefined' && typeof window?.electronAPI !== 'undefined';
    }
    return false;
};

/**
 * Opens a URL using the device's default browser/app
 * @param {string} url - URL to open
 * @returns {Promise<void>}
 */
export const openURL = async (url) => {
    try {
        const supported = await Linking.canOpenURL(url);
        if (supported) {
            await Linking.openURL(url);
        } else {
            console.log(`Can't open this URL: ${url}`);
        }
    } catch (error) {
        console.error('openURL error', error);
    }
};

/**
 * Returns color code for food item type indicator
 * @param {string} item_type - Item type ('veg', 'non_veg', 'egg', 'vegan')
 * @returns {string|undefined} Color hex code
 */
export const getItemTypeIconColor = (item_type) => {
    if (item_type === 'non_veg' || item_type === 'non veg') {
        return '#FF0000';
    } else if (item_type === 'veg') {
        return '#008000';
    } else if (item_type === 'egg') {
        return '#FFA500';
    } else if (item_type === 'vegan') {
        return '#4CAF50';
    }
};

/**
 * Generates Yup validation schema for mobile/email based on app settings
 * Handles domain allowlisting/blocklisting and employee ID validation
 * @param {Object} params
 * @param {Object} params.settings - App settings object
 * @param {Object} params.Yup - Yup validation library
 * @param {Object} params.scheme - Base validation schema
 * @param {Object} [params.initialValues={}] - Initial form values
 * @param {string} [params.page=null] - Page name ('register', etc.)
 * @returns {Object} Object with scheme, initialValues, and identifier
 */
export const getIdentifierYupObject = ({ settings, Yup, scheme, initialValues = {}, page = null }) => {
    let tempScheme = { ...scheme };
    const allowed_domains = settings?.allowed_domains;
    const blocked_domains = settings?.blocked_domains;
    const show_emp_id_in_signup = settings?.show_emp_id_in_signup;

    if (!settings?.disable_mobile) {
        tempScheme.mobile = Yup.string()
            .required('Mobile number is required');
        initialValues.mobile = '';
    } else if (!settings?.disable_email) {
        let emailSchema = Yup.string()
            .email('Invalid email format')
            .required('Email is required');

        const allowedDomains = (allowed_domains || '')
            .split(',')
            .map(d => d.trim().toLowerCase())
            .filter(Boolean);

        const blockedDomains = (blocked_domains || '')
            .split(',')
            .map(d => d.trim().toLowerCase())
            .filter(Boolean);

        if (allowedDomains.length > 0) {
            emailSchema = emailSchema.test(
                'allowed-domain',
                `Only ${allowedDomains.join(', ')} domains are allowed`,
                (value) => {
                    if (!value) { return false; }
                    const domain = value.split('@')[1]?.toLowerCase();
                    return allowedDomains.includes(domain);
                }
            );
        }

        if (blockedDomains.length > 0) {
            emailSchema = emailSchema.test(
                'blocked-domain',
                `Emails from these domains are not allowed: ${blockedDomains.join(', ')}`,
                (value) => {
                    if (!value) {
                        return false;
                    }
                    const domain = value.split('@')[1]?.toLowerCase();
                    return !blockedDomains.includes(domain);
                }
            );
        }

        tempScheme.email = emailSchema;
        initialValues.email = '';
    }

    if (page === 'register' && !!show_emp_id_in_signup) {
        tempScheme.emp_id = Yup.string()
            .required('Employee Id is required');
        initialValues.emp_id = '';
    }

    return {
        scheme: tempScheme,
        initialValues,
        identifier: tempScheme.mobile ? 'mobile' : 'email',
    };
};

/**
 * Extracts and sanitizes cart canteens data from Redux store
 * Removes unnecessary properties to prepare for API submission
 * @returns {Object} Cleaned canteens object with cart items
 */
export const getCartCanteens = () => {
    const canteens = JSON.parse(JSON.stringify(store.getState().cart?.canteens || {}));
    for (let canteen_id in canteens) {
        canteens[canteen_id]['cart'] = (canteens[canteen_id]?.cart || []).map(item => ({
            item_id: item.item_id,
            canteen_id: item.canteen_id,
            item_name: item.item_name,
            item_qty: item.item_qty,
            item_price: item.item_price,
            item_type: item.item_type,
            category_id: item.category_id,
            has_inventory: item.has_inventory,
        }));
        canteens[canteen_id]['canteen'] = {
            canteen_id: canteens[canteen_id]['canteen'].canteen_id,
            canteen_name: canteens[canteen_id]['canteen'].canteen_name,
            order_note: canteens[canteen_id]['canteen'].order_note,
            slot_id: canteens[canteen_id]['canteen'].slot_id,
            session_id: canteens[canteen_id]['canteen'].session_id,
            delivery_date: canteens[canteen_id]['canteen'].delivery_date,
        };
    }
    return canteens;
};

/**
 * 
 * @param {*} ms 
 * @returns 
 */
export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Pads data array with empty items to fill grid columns evenly
 * @param {Object} params
 * @param {number} params.numColumns - Number of columns in grid
 * @param {Array} params.data - Data array to pad
 * @param {string} params.key - Key name for unique identifier
 * @param {number} [params.page=1] - Page number for unique keys
 * @returns {Array} Padded data array
 */
export const prepareDataForFlatList = ({ numColumns, data, key, page = 1 }) => {
    const remainder = (data.length) % numColumns;
    if (remainder !== 0) {
        const itemsToAdd = numColumns - remainder;
        for (let i = 0; i < itemsToAdd; i++) {
            let params = { isEmpty: true };
            params[key] = `empty-${page}${i}`;
            data.push(params);
        }
    }
    return data;
};


/**
 * Attaches an authentication interceptor to the given Axios instance
 * Automatically adds Bearer token from storage to request headers
 * @param {*} axiosInstance
 */
export const attachAuthInterceptor = (axiosInstance) => {
    axiosInstance.interceptors.request.use(
        async (config) => {
            const accessToken = await storage.getData('accessToken');

            if (accessToken) {
                config.headers = config.headers || {};
                config.headers.Authorization = `Bearer ${accessToken}`;
                config.__ccAccessToken = accessToken;
            }

            return config;
        },
        (error) => {
            console.error('Request interceptor error:', error);
            return Promise.reject(error);
        }
    );
};

/**
 * Attaches a token refresh interceptor to the given Axios instance
 * Automatically attempts to refresh token on 401 responses and retry original request
 * @param {*} axiosInstance
 */
export const attachRefreshInterceptor = (axiosInstance) => {
    axiosInstance.interceptors.response.use(
        (response) => response,

        async (error) => {
            const originalRequest = error.config;

            // Avoid infinite loop
            if (
                error.response?.status === 401 &&
                !originalRequest?._retry &&
                !originalRequest?.url?.includes('/accessToken') &&
                !isPublicAuthRequest(originalRequest)
            ) {
                originalRequest._retry = true;

                try {
                    const failedAccessToken = getRequestAccessToken(originalRequest);
                    const currentAccessToken = await storage.getData('accessToken');
                    if (!failedAccessToken || !currentAccessToken) {
                        throw new Error('No access token');
                    }
                    if (currentAccessToken !== failedAccessToken) {
                        originalRequest.headers = originalRequest.headers || {};
                        originalRequest.headers.Authorization = `Bearer ${currentAccessToken}`;
                        originalRequest.__ccAccessToken = currentAccessToken;
                        return axiosInstance(originalRequest);
                    }

                    if (!accessTokenRotationPromise || rotatingAccessToken !== failedAccessToken) {
                        rotatingAccessToken = failedAccessToken;
                        accessTokenRotationPromise = axios.post(
                            CASH_COUNTER_API_URL + '/accessToken',
                            { accessToken: failedAccessToken },
                            { headers: { ...baseHeaders, ...mobileHeaders }, timeout: REQUEST_TIME_OUT },
                        ).then(async ({ data }) => {
                            if (!data?.accessToken) throw new Error('Token rotation returned no access token');
                            await storage.storeData('accessToken', data.accessToken);
                            return data.accessToken;
                        }).finally(() => {
                            accessTokenRotationPromise = null;
                            rotatingAccessToken = null;
                        });
                    }
                    const accessToken = await accessTokenRotationPromise;

                    // Retry original request
                    originalRequest.headers = originalRequest.headers || {};
                    originalRequest.headers.Authorization =
                        `Bearer ${accessToken}`;
                    originalRequest.__ccAccessToken = accessToken;

                    return axiosInstance(originalRequest);
                } catch (refreshError) {
                    console.error('Refresh token failed:', refreshError);
                    await resetExpiredSession(getRequestAccessToken(originalRequest));
                }
            }

            return Promise.reject(error);
        }
    );
};
